export const BOOKING_STATUSES = {
	BOOKED: 'BOOKED',
	PENDING_BOOKING: 'PENDING_BOOKING',
	CANCELLED: 'CANCELLED',
};
